import client, { unwrap } from "./client"

// The voice relay is a separate host from the REST API (iOS reads it as API_HOST).
export const VAN_RELAY_BASE = import.meta.env.VITE_VAN_RELAY_BASE ?? ""

// Per-item conversation memory, carried into the next session as old_memory.
export async function fetchVanMemory(itemId) {
  const response = await client.get("/van/memory/", { params: { item_id: itemId } })
  return unwrap(response)?.memory ?? ""
}

// Saves a session summary; score is 1-5, or "INCOMPLETE" when Van declined to judge it.
export async function saveVanMemory(itemId, { memory, score, scoreExplanation }) {
  const payload = { item_id: itemId, memory }
  if (score !== undefined) {
    payload.score = score
    payload.score_explanation = scoreExplanation ?? ""
  }
  await client.put("/van/memory/", payload)
}

// Relay summary job for a session: {status, error, result: {memory, score, score_explanation}}.
// Resolves null on 404, which the relay returns when no job is saved for the session.
export async function fetchVanSessionSummary(sessionId, restaurantId) {
  const query = new URLSearchParams({ restaurant_id: restaurantId })
  const response = await fetch(
    `${VAN_RELAY_BASE}/van/sessions/${encodeURIComponent(sessionId)}/summary?${query}`
  )
  if (response.status === 404) return null
  if (!response.ok) throw new Error(`VAN summary failed (${response.status})`)
  return response.json()
}
